/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sorter_Ex_NoteInputs */

const en_sorter_ex_note = /** @type {(inputs: Sorter_Ex_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The tags array still reads z, a because element order is data. Inside meta, the keys were reordered independently of the parent.`)
};

const ko_sorter_ex_note = /** @type {(inputs: Sorter_Ex_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`tags 배열은 요소 순서가 데이터이므로 여전히 z, a로 읽힙니다. meta 안에서는 부모와 무관하게 키가 다시 정렬되었습니다.`)
};

const ja_sorter_ex_note = /** @type {(inputs: Sorter_Ex_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`tags 配列は要素順序がデータなので、依然として z, a と読めます。meta の内部では親とは無関係にキーが並べ替えられています。`)
};

/**
* | output |
* | --- |
* | "The tags array still reads z, a because element order is data. Inside meta, the keys were reordered independently of the parent." |
*
* @param {Sorter_Ex_NoteInputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const sorter_ex_note = /** @type {((inputs?: Sorter_Ex_NoteInputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sorter_Ex_NoteInputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_sorter_ex_note(inputs)
	if (locale === "ko") return ko_sorter_ex_note(inputs)
	return ja_sorter_ex_note(inputs)
});